import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import CardValores from './cardValores'
import 'swiper/css'
import 'swiper/css/navigation'
import Container from './container'

export default function Valores() {
  const depoimentos = [
    {
      title: 'COMPROMISSO',
      description: (
        <>
          Cumprir o que foi prometido com <br /> qualidade e pontualidade.
        </>
      ),
    },
    {
      title: 'INTEGRIDADE',
      description: (
        <>
          Agir com ética e transparência em <br /> todas as relações.
        </>
      ),
    },
    {
      title: 'FOCO EM PESSOAS',
      description: (
        <>
          Cultivar relações baseadas na <br /> credibilidade e na lealdade.
        </>
      ),
    },
    {
      title: 'ATITUDE EMPREENDEDORA',
      description: (
        <>
          Incentivar autonomia e inovação disruptiva,
          <br /> buscando antecipar problemas e <br />
          gerar soluções com agilidade.
        </>
      ),
    },
    {
      title: 'EXCELÊNCIA EM RESULTADOS',
      description: (
        <>
          Alcançar metas com eficiência, eficácia
          <br /> e efetividade, com foco na melhoria <br />
          contínua e na superação de expectativas.
        </>
      ),
    },
  ]

  const clientes = [
    {
      src: '../assets/clientes/ADAPTI.png',
      alt: 'Adopie',
    },
    {
      src: '../assets/clientes/ARREZO.png',
      alt: 'Arezzo',
    },
    {
      src: '../assets/clientes/ENERGISA.png',
      alt: 'Energisa',
    },
    {
      src: '../assets/clientes/GABSTER.png',
      alt: 'Gabster',
    },
    {
      src: '../assets/clientes/GRSA.png',
      alt: 'GRSA',
    },
    {
      src: '../assets/clientes/MERCANTIL.png',
      alt: 'Mercantil',
    },
    {
      src: '../assets/clientes/MUEVY.png',
      alt: 'Muevy',
    },
    {
      src: '../assets/clientes/PERRUZZO.png',
      alt: 'Peruzzo',
    },
    {
      src: '../assets/clientes/PESTANA.png',
      alt: 'Pestana',
    },
    {
      src: '../assets/clientes/ZALLPY.png',
      alt: 'Sallpy',
    },
    {
      src: '../assets/clientes/SELCO.png',
      alt: 'Selco',
    },
    {
      src: '../assets/clientes/SODEXO.png',
      alt: 'Sodexo',
    },
    {
      src: '../assets/clientes/TERMOLAR.png',
      alt: 'Termolar',
    },
    {
      src: '../assets/clientes/TERMOMECANICA.png',
      alt: 'Termomecanica',
    },
    {
      src: '../assets/clientes/UNIFIQUE.png',
      alt: 'Unifique',
    },
    {
      src: '../assets/clientes/VIRTUEYES.png',
      alt: 'Virtueyes',
    },
  ]

  const topCarouselRef = useRef(null)
  const bottomCarouselRef = useRef(null)
  const [isTopHovered, setIsTopHovered] = useState(false)
  const [isBottomHovered, setIsBottomHovered] = useState(false)
  const topAnimationRef = useRef(null)
  const bottomAnimationRef = useRef(null)
  const swiperRef = useRef(null)
  const [activeSlide, setActiveSlide] = useState(0)
  const [totalSlides, setTotalSlides] = useState(0)
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640

  const getSlidesPerView = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 640) return 1
      if (window.innerWidth < 1024) return 2
      return 3
    }
    return 3
  }

  const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView())

  const handleSlideChange = swiper => {
    setActiveSlide(swiper.realIndex)
  }

  const goToSlide = index => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideTo(index)
    }
  }

  useEffect(() => {
    const animateTopCarousel = () => {
      if (topCarouselRef.current) {
        const content = topCarouselRef.current
        const scrollAmount = 1 // Velocidade de scroll (pixels por frame)

        const scroll = () => {
          if (!isTopHovered) {
            content.scrollLeft += scrollAmount

            // Se chegou ao final, volta para o início
            if (
              content.scrollLeft >=
              content.scrollWidth - content.clientWidth
            ) {
              content.scrollLeft = 0
            }
          }

          topAnimationRef.current = requestAnimationFrame(scroll)
        }

        topAnimationRef.current = requestAnimationFrame(scroll)
      }
    }

    // Iniciar a animação
    animateTopCarousel()

    // Limpar a animação quando o componente for desmontado
    return () => {
      if (topAnimationRef.current) {
        cancelAnimationFrame(topAnimationRef.current)
      }
    }
  }, [isTopHovered])

  useEffect(() => {
    const animateBottomCarousel = () => {
      if (bottomCarouselRef.current) {
        const content = bottomCarouselRef.current
        const scrollAmount = 1 // Velocidade de scroll (pixels por frame)

        // Iniciar do final para scrollar para a direita
        if (content.scrollLeft === 0) {
          content.scrollLeft = content.scrollWidth - content.clientWidth
        }

        const scroll = () => {
          if (!isBottomHovered) {
            content.scrollLeft -= scrollAmount

            // Se chegou ao início, volta para o final
            if (content.scrollLeft <= 0) {
              content.scrollLeft = content.scrollWidth - content.clientWidth
            }
          }

          bottomAnimationRef.current = requestAnimationFrame(scroll)
        }

        bottomAnimationRef.current = requestAnimationFrame(scroll)
      }
    }

    // Iniciar a animação
    animateBottomCarousel()

    // Limpar a animação quando o componente for desmontado
    return () => {
      if (bottomAnimationRef.current) {
        cancelAnimationFrame(bottomAnimationRef.current)
      }
    }
  }, [isBottomHovered])

  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(getSlidesPerView())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setTotalSlides(clientes.length)
  }, [clientes.length])

  return (
    <section className="text-white bg-[#040116]">
      <div className="bg-cover-valores py-32">
        <header className="mb-20 flex items-center justify-center">
          <h2 className="font-inter-light text-5xl group relative inline-block">
            Valores
            <span className="absolute left-0 bottom-[-6px] h-[2px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-full transition-all duration-200" />
          </h2>
        </header>
        <main className="overflow-hidden space-y-8">
          {/* Carrossel superior - move para a esquerda */}
          <div className="w-full overflow-hidden">
            <div
              ref={topCarouselRef}
              className="flex whitespace-nowrap overflow-x-scroll hide-scrollbar gap-6"
              style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
              onMouseEnter={() => setIsTopHovered(true)}
              onMouseLeave={() => setIsTopHovered(false)}
            >
              {/* Duplicamos os itens para criar efeito de loop infinito */}
              {[...depoimentos, ...depoimentos].map((depoimento, index) => (
                <div key={index} className="inline-block">
                  <CardValores
                    title={depoimento.title}
                    description={depoimento.description}
                  />
                </div>
              ))}
            </div>
          </div>
          {/* Carrossel inferior - move para a direita */}
          <div className="w-full overflow-hidden">
            <div
              ref={bottomCarouselRef}
              className="flex whitespace-nowrap overflow-x-scroll hide-scrollbar gap-6"
              style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
              onMouseEnter={() => setIsBottomHovered(true)}
              onMouseLeave={() => setIsBottomHovered(false)}
            >
              {/* Duplicamos os itens para criar efeito de loop infinito */}
              {[...depoimentos, ...depoimentos].map((depoimento, index) => (
                <div key={index} className="inline-block">
                  <CardValores
                    title={depoimento.title}
                    description={depoimento.description}
                  />
                </div>
              ))}
            </div>
          </div>
        </main>
        <Container className="space-y-22 mt-[141px]">
          <h2 className="text-4xl md:text-5xl font-normal text-center">
            Quem confia em nós
          </h2>

          <div className="mt-12 md:mt-24 relative certificados-carousel">
            <Swiper
              ref={swiperRef}
              modules={[Navigation, Autoplay]}
              spaceBetween={30}
              slidesPerView={slidesPerView}
              slidesPerGroup={1}
              navigation={!isMobile}
              loop={false}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              onSlideChange={swiper => handleSlideChange(swiper)}
              onInit={swiper => {
                setActiveSlide(swiper.realIndex)
              }}
              className="mySwiper px-8"
              style={{
                '--swiper-navigation-color': '#fff',
                '--swiper-navigation-size': '18px',
                '--swiper-navigation-sides-offset': '0px',
              }}
            >
              {clientes.map((cliente, index) => (
                <SwiperSlide key={index}>
                  <div className="flex items-center justify-center h-[70px] px-8">
                    <img
                      src={cliente.src}
                      alt={cliente.alt}
                      className="max-h-full max-w-full object-cover"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex justify-center mt-8 gap-4">
              <button
                type="button"
                onClick={() => {
                  const prevIndex =
                    (activeSlide - 1 + totalSlides) % totalSlides
                  goToSlide(prevIndex)
                }}
                className="md:hidden"
              >
                <ChevronLeft className="text-white" />
              </button>
              <div className="flex flex-row gap-3 items-center">
                {Array.from({ length: 3 }).map((_, i) => {
                  const isActive =
                    Math.floor(activeSlide / Math.ceil(totalSlides / 3)) === i

                  const isThirdDot = i === 2

                  return (
                    <div
                      key={i}
                      onClick={() => {
                        goToSlide(i * Math.ceil(totalSlides / 3))
                      }}
                      className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                        isActive
                          ? isThirdDot
                            ? 'w-[6px] bg-transparent border border-white'
                            : 'w-[20px] bg-transparent border border-white'
                          : isThirdDot
                            ? 'w-[6px] bg-white'
                            : 'w-[20px] bg-white'
                      }`}
                      aria-label={`Go to group ${i + 1}`}
                    />
                  )
                })}
              </div>
              <button
                type="button"
                onClick={() => {
                  const nextIndex = (activeSlide + 1) % totalSlides
                  goToSlide(nextIndex)
                }}
                className="md:hidden"
              >
                <ChevronRight className="text-white" />
              </button>
            </div>
          </div>
        </Container>
      </div>
    </section>
  )
}